import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-encuesta-lista-responde',
  templateUrl: './encuesta-lista-responde.component.html',
  styleUrls: ['./encuesta-lista-responde.component.css']
})
export class EncuestaListaRespondeComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsFicha: DataTables.Settings = {};
  public dtTriggerFicha: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = ""; public selectPeriodo: string = '';
  public vecListaResponde = []; public vecPeriodo = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerFicha = new Subject<any>();
    this.dtOptionsFicha[0] = this.tools.OpcionesTabla(10);

    this.encabezado = "Lista de estudiantes";
    this.nombreBeca = localStorage.getItem('modNom');
    this.cargarPeriodos();
  }
  //FUNCION QUE CARGA TODAS LOS PERIODOS ACADEMICOS DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = [];
    const res = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(3, "na", "na", "na").subscribe(translated => { resolve(translated) }));
    if (res.success) {
      this.selectPeriodo = res.carrera[0]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
  }
  //ABRIR EL MODAL PARA ESCOGER EL PERIODO DE DE CONSULTA
  verFechasRespuesta(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //BUSCAR LAS FICHAS RESPONDIDAS EN EL PERIODO ACADEMICO
  async verResultados() {
    var table2 = $('#tblFichas').DataTable({ destroy: true });
    table2.destroy();
    this.cerrarModal();
    this.cargando.abrir();
    this.vecListaResponde = [];
    const resResCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(15, this.selectPeriodo, '2', 'na', 'na').subscribe(translated => { resolve(translated) }));

    if (resResCuest.resultado) {
      this.vecListaResponde = resResCuest.fichaEstudiantil;
      this.dtTriggerFicha.next();
    }
    else
      this.alerti.message('No se encntró información de encuestas registradas');
    this.cargando.cerrar();
  }
  //FUNCION QUE ABRA LAS RESPUESTAS DE UNA FICHA SELECCIONADA
  verRespuesta(objFicha: any) {
    localStorage.setItem('localVerResp', objFicha.strIdResponde);
    this.ruta.navigate(["/gestion/verRespuestaFicha"]);
  }
  //FUNCION PARA CERRAR UN MODAL
  cerrarModal() {
    this.mr.close();
  }
}
